import { render } from "./AuthorizedContactsRow.vue?vue&type=template&id=38df9cee&ts=true"
import script from "./AuthorizedContactsRow.ts?vue&type=script&lang=ts&external"
export * from "./AuthorizedContactsRow.ts?vue&type=script&lang=ts&external"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__